import React, { useContext, useEffect, useState } from "react";
import { FiShoppingCart } from "react-icons/fi";
import { RxCross2 } from "react-icons/rx";
import { useNavigate } from "react-router-dom";
import { showToast } from "../services/toastService";
import { ProductContext } from "../contexts/ProductContext";

// function WishList({ hideWishlist }) {
function WishList() {
  const { setIsWishlistOpen} = useContext(ProductContext);

  const notifySuccess = (message) => {
    showToast(message, "dark");
  };
  const notifyError = (message) => {
    showToast(message, "warn");
  };
  const [wishlistItems, setWishlistItems] = useState(
    JSON.parse(localStorage.getItem("wishlistItems")) || []
  );

  useEffect(() => {
    document.body.style.overflow = "hidden";

    return () => {
      document.body.style.overflow = "scroll";
    };
  }, []);

  const CloseWishlist = () => {
    setIsWishlistOpen(false);
  };

  const navigate = useNavigate();

  const addToCart = (product) => {
    let cartItems = JSON.parse(localStorage.getItem("cartItems")) || [];

    const isProductInCart = cartItems.some((item) => item.id === product.id);

    if (isProductInCart) {
      notifyError("Product is already in the cart");
      return;
    }
    const productToAdd = { ...product };
    cartItems.push(productToAdd);
    localStorage.setItem("cartItems", JSON.stringify(cartItems));
    notifySuccess("Product Added Succesfull");
  };

  const NavigateToProductPage = (product) => {
    const extractedId = product.id.substring(product.id.lastIndexOf("/") + 1);
    CloseWishlist();
    navigate(`/products/${encodeURIComponent(extractedId)}`);
  };
 

  const removeItemFromWishlist = (event,index) => {
    event.stopPropagation();
    const updatedWishlistItems = [...wishlistItems];
    updatedWishlistItems.splice(index, 1);
    localStorage.setItem("wishlistItems", JSON.stringify(updatedWishlistItems));
    setWishlistItems(updatedWishlistItems);
  };
  

  return (
    <div
      id="wishlistItems"
      className="top-0 right-0 z-[99] fixed flex justify-center items-center w-screen h-screen"
    >
      <div
        className="bg-gray-400 bg-opacity-50 shadow-md w-[30%] md:w-[50%] lg:w-[70%] h-full"
        onClick={CloseWishlist}
      ></div>
      {/* Main Container */}
      <div className="flex flex-col justify-start items-center bg-white shadow-md w-[70%] md:w-[50%] lg:w-[30%] h-full">
        <div className="flex justify-between items-center p-6 border-b w-full heading">
          <h3 className="font-primaryFont font-semibold text-lg uppercase tracking-wider">
            Wishlist
          </h3>
          <button
            className="ml-auto focus:outline-none"
            onClick={CloseWishlist}
          >
            <RxCross2 className="text-2xl text-gray-500 hover:text-gray-700" />
          </button>
        </div>
        <div className="cart-item-container overflow-y-scroll">
          <div className="p-4 cart-card-container">
            {wishlistItems &&
              wishlistItems.map((product, index) => (
                <div
                  onClick={() => NavigateToProductPage(product)}
                  key={product.id}
                  className="flex justify-between items-start gap-2 py-2 border-b w-full cursor-pointer cart-card"
                >
                  <div className="p-2 w-[25%] image-container">
                    <img src={product.featuredImage.url} alt={product.title} />
                  </div>
                  <div className="relative flex flex-col justify-start items-start pt-2 w-[70%] text-sm detail-container">
                    {/* <h2 className="mb-2 tracking-wider">
                      {product.title.split(" - ")[0]}
                    </h2> */}
                    <div className="flex justify-between items-center mb-2 w-full heading-container">
                  <h2 className="tracking-wider">
                    {product.title.split(" - ")[0]}
                  </h2>
                  <button
                    className="ml-auto focus:outline-none"
                    onClick={(event) =>  removeItemFromWishlist(event,index)}
                  >
                    <RxCross2 className="text-2xl text-gray-500 hover:text-gray-700" />
                  </button>
                </div>
                    <p className="text-xs">
                      <span className="font-semibold">Color:</span>{" "}
                      {
                        product.options.find(
                          (option) => option.name === "Color"
                        ).values[0]
                      }
                    </p>
                    <p className="text-xs">
                      <span className="font-semibold">Size:</span>{" "}
                      {product.selectedSize}
                    </p>
                    <p className="text-xs">
                      <span className="font-semibold">Quantity:</span>{" "}
                      {product.selectedQuantity}
                    </p>
                    <div className="relative flex justify-between items-center mt-2 w-full quantity-total-container">
                      <div className="w-1/2 font-secondaryFont total-container">
                        <span className="font-semibold capitalize tracking-widest">
                          Rs {product.variants.nodes[0].price.amount}
                        </span>
                      </div>

                      <button
                        onClick={(event) => {
                          event.stopPropagation();
                          addToCart(product);
                        }}
                        className="flex justify-center items-center gap-2 bg-black hover:bg-primary hover:shadow-md p-2 rounded-md w-auto font-primaryFont font-semibold text-lg text-white tracking-wider cartbtn"
                      >
                        <FiShoppingCart />
                      </button>
                    </div>
                  </div>
                </div>
              ))}
               {wishlistItems.length <= 0 ? <p className="font-bold text-center text-red-500 tracking-wider">No Products <span className="text-blue-500 underline">Please Add Products</span></p>  : <p></p> }

          </div>
        </div>
      <div className="py-4 space-container"></div>
      </div>
    </div>
  );
}

export default WishList;
